import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'
const selector = (state: TRootState) => state.project

const data = createSelector(selector, state => state.data)

const isLoading = createSelector(selector, state => state.isLoading)

const isLoaded = createSelector(
  selector,
  state => !state.isLoading && (!!state.data.id || state.isNewProject)
)

const id = createSelector(selector, state => state.data?.id || '')

const isRendering = createSelector(selector, state => state.isRendering)

const meta = createSelector(data, state => state.meta)

const metaData = createSelector(selector, state => state.metaData)

const aiFlowVideoModelCode = createSelector(
  metaData,
  metaData => metaData?.videoModel
)

const aiFlowImageModelCode = createSelector(
  metaData,
  metaData => metaData?.imageModel
)

const customStyleInfo = createSelector(
  metaData,
  metaData => metaData?.customStyleInfo
)

const hasCustomStyle = createSelector(
  customStyleInfo,
  customStyleInfo => !!customStyleInfo && customStyleInfo.isVideoStyleSuitable
)

export const projectSelectors = {
  data,
  isLoading,
  isLoaded,
  id,
  isRendering,
  meta,
  metaData,
  aiFlowVideoModelCode,
  aiFlowImageModelCode,
  hasCustomStyle,
  customStyleInfo
}
